import "./index.scss";
const ASPECT_RATIO_ROOT = "--aspect-ratio";

const Background = () => {
  const styles = {
    left: {
      bottom: 0,
      left: 0,
      "--width": `347px`,
      [ASPECT_RATIO_ROOT]: 431 / 347,
    },
    right: {
      top: "120px",
      right: 0,
      "--width": `304px`,
      [ASPECT_RATIO_ROOT]: 293 / 304,
    },
  };

  return (
    <div className="background">
      <div className="shape">
        <div className="shape__container" style={{ ...styles.left }}>
          <div className="shape__abstr">
            <svg
              width="347"
              height="431"
              viewBox="0 0 347 431"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_4_419)">
                <path
                  d="M295.493 232.93L340.327 275.979C343.419 278.947 342.491 284.105 338.56 285.811L121.498 379.997C118.575 381.266 115.171 380.028 113.745 377.178L43.7739 237.359C41.7649 233.344 44.7146 228.626 49.2036 228.674L291.402 231.258C292.929 231.275 294.392 231.872 295.493 232.93Z"
                  fill="url(#paint0_linear_4_419)"
                  fillOpacity="0.1"
                />
                <path
                  d="M213.451 226.243L228.468 286.675C229.49 290.788 225.96 294.765 221.729 294.268L-9.7587 267.048C-12.902 266.678 -15.1246 263.913 -14.827 260.743L-0.0253033 103.053C0.397726 98.5466 5.45416 95.9361 9.23743 98.2712L210.906 222.748C212.179 223.533 213.088 224.782 213.451 226.243Z"
                  fill="url(#paint1_linear_4_419)"
                  fillOpacity="0.1"
                  stroke="url(#paint2_linear_4_419)"
                  strokeWidth="0.5"
                />
                <path
                  d="M35.2967 391.535L125.072 316.345C129.216 312.874 135.477 316.224 134.889 321.598L119.336 463.716C118.804 468.58 112.987 470.796 109.354 467.519L35.1312 400.591C32.4233 398.149 32.5014 393.877 35.2967 391.535Z"
                  fill="url(#paint3_linear_4_419)"
                  fillOpacity="0.1"
                />
                <path
                  d="M143.16 54.3886L217.917 37.817C222.74 36.7479 226.717 41.64 224.684 46.143L205.821 87.9398C204.458 90.9602 200.905 92.3037 197.884 90.9405L141.99 65.7153C136.731 63.3416 137.526 55.6374 143.16 54.3886Z"
                  fill="url(#paint4_linear_4_419)"
                  fillOpacity="0.1"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_4_419"
                  x1="238.718"
                  y1="344.641"
                  x2="-5.20614"
                  y2="179.82"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_4_419"
                  x1="107.117"
                  y1="295.313"
                  x2="-21.0034"
                  y2="32.9274"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_4_419"
                  x1="212.5"
                  y1="279"
                  x2="-2.11886"
                  y2="92.1005"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFA800" stopOpacity="0.22" />
                  <stop offset="1" stopColor="#FFA800" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_4_419"
                  x1="156.872"
                  y1="408.148"
                  x2="-15.0246"
                  y2="391.264"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_4_419"
                  x1="216.482"
                  y1="64.3166"
                  x2="111.674"
                  y2="91.965"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <clipPath id="clip0_4_419">
                  <rect width="347" height="431" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div className="emulation"></div>
      <div className="shape">
        <div className="shape__container" style={{ ...styles.right }}>
          <div className="shape__abstr">
            <svg
              width="304"
              height="293"
              viewBox="0 0 304 293"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M46.0735 90.1081L33.2439 45.8438C32.3594 42.7919 34.867 39.8234 38.0238 40.1855L212.323 60.1778C214.67 60.447 216.397 62.5041 216.257 64.8626L209.351 180.585C209.153 183.907 205.51 185.843 202.645 184.148L48.0811 92.6984C47.1067 92.1219 46.3887 91.1955 46.0735 90.1081Z"
                fill="url(#paint0_linear_4_425)"
                fillOpacity="0.1"
              />
              <path
                d="M96.2752 124.818L109.037 80.4453C109.905 77.4259 113.647 76.1808 116.179 78.0686L254.732 181.367C256.613 182.77 257.015 185.369 255.649 187.295L187.684 283.064C185.741 285.801 181.527 285.603 179.963 282.7L96.6136 128.006C96.0877 127.03 95.9668 125.891 96.2752 124.818Z"
                fill="url(#paint1_linear_4_425)"
                fillOpacity="0.1"
              />
              <path
                d="M271.952 84.7271L186.43 99.7261C182.482 100.418 179.703 95.9465 182.073 92.7139L244.748 7.22174C246.893 4.29601 251.449 5.02941 252.568 8.4804L275.415 78.9735C276.249 81.5454 274.615 84.2601 271.952 84.7271Z"
                fill="url(#paint2_linear_4_425)"
                fillOpacity="0.1"
              />
              <path
                d="M77.6997 261.229L23.5526 244.155C20.059 243.054 19.3194 238.438 22.2937 236.3L49.9017 216.455C51.8967 215.02 54.6766 215.475 56.1107 217.47L82.6499 254.39C85.1472 257.864 81.7802 262.516 77.6997 261.229Z"
                fill="url(#paint3_linear_4_425)"
                fillOpacity="0.1"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_4_425"
                  x1="123.945"
                  y1="39.4238"
                  x2="219.471"
                  y2="235.691"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_4_425"
                  x1="190.162"
                  y1="119.888"
                  x2="175.157"
                  y2="335.871"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_4_425"
                  x1="200.044"
                  y1="28.9878"
                  x2="304.164"
                  y2="103.557"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_4_425"
                  x1="34.2979"
                  y1="227.671"
                  x2="111.849"
                  y2="248.773"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF8E0A" />
                  <stop offset="1" stopColor="#FF8E0A" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Background;
